module.exports = __webpack_public_path__ + "img/17_68.785634e6.png";